import { useState } from 'react'
import SimpleReactValidator from 'simple-react-validator'
const validator = new SimpleReactValidator()
export function newFormField(defaultValue, errors = [], rules = [], customRule = null) {
  let field = {
    value: defaultValue,
    valid: errors == null || errors.length === 0,
    errors: errors,
    rules: rules,
    customRule: customRule,
  }

  field.checkValid = () => {
    var { rules, customRule } = field
    var errors = []
    if (rules) {
      for (let i = 0; i < rules.length; i++) {
        const rule = rules[i]
        if (!validator.check(field.value, rule.rule)) {
          errors.push(rule.message)
        }
      }
    }

    if (customRule) {
      errors = errors.concat(customRule())
    }

    field.errors = errors
    field.valid = errors.length === 0
    field.onChecked?.call()
    return field.valid
  }

  return field
}

export function useFormField(options) {
  let { value, errors, rules, customRule } = options
  const [field, setField] = useState(newFormField(value, errors ?? [], rules ?? [], customRule))
  const setHookField = (newValue) => {
    setField({ ...newFormField(newValue, field.errors, field.rules, field.customRule) })
  }
  return [field, setHookField, setField]
}

export function useForm(formFields) {
  let form = {
    fields: formFields,
  }
  form.valid = () => {
    formFields.forEach((element) => {
      element.checkValid()
    })
    return formFields.every((item) => item.valid)
  }

  return [form]
}

export function newValidationDescription(validations, message) {
  return {
    validations,
    message,
  }
}

export const analyzeOptionsAndAnswers = ({ options, chosen, correct }) => {
  const analysis = {
    options: options.map((option) => ({
      option,
      status: chosen.includes(option)
        ? correct.includes(option)
          ? 'chosen-correct'
          : 'chosen-incorrect'
        : 'unchosen',
    })),
    summary: {
      chosenCorrect: chosen.filter((opt) => correct.includes(opt)),
      chosenIncorrect: chosen.filter((opt) => !correct.includes(opt)),
      missedCorrect: correct.filter((opt) => !chosen.includes(opt)),
      score: chosen.filter((opt) => correct.includes(opt)).length,
      totalCorrect: correct.length,
      totalChosen: chosen.length,
    },
  }

  return analysis
}

export const replaceWithInjectableReview = (content) => {
  let count = 0
  return content.replace(/______/g, (a, b, c) => {
    return `<InjectableFillTheBlankReview answers={answers} feedbacks={feedbacks} qKey={qKey} correctAnswers={correctAnswers} index={${count++}}/>`
  })
}

/**
 * @template T
 * @param {T} func
 * @param {number} delay
 * @returns {T}
 */
export const debounceFunc = (func, delay = 500) => {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => func(...args), delay)
  }
}

/**
 * @template T
 * @param {T} func
 * @param {number} delay
 * @returns {T}
 */
export const throttleFunc = (func, delay) => {
  let lastCall = 0
  return (...args) => {
    const now = new Date().getTime()
    if (now - lastCall >= delay) {
      lastCall = now
      func(...args)
    }
  }
}

/**
 * Safely calculates the sum of all numeric elements in an array.
 * Non-numeric values are ignored.
 *
 * @param {number[]} arr - The array containing numbers.
 * @returns {number} - The sum of numeric elements.
 */
export function sumArray(arr) {
  if (!Array.isArray(arr)) {
    throw new TypeError('Input must be an array.')
  }

  return arr.reduce((total, value) => {
    // Only add if value is a finite number
    if (typeof value === 'number' && Number.isFinite(value)) {
      return total + value
    }
    return total // Ignore non-numeric values
  }, 0)
}
